import { render, staticRenderFns } from "./e-document-tag.vue?vue&type=template&id=dc4f4b7c&scoped=true&lang=pug"
import script from "./e-document-tag.vue?vue&type=script&lang=js"
export * from "./e-document-tag.vue?vue&type=script&lang=js"
import style0 from "./e-document-tag.vue?vue&type=style&index=0&id=dc4f4b7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4f4b7c",
  null
  
)

export default component.exports